import { TabsStyle } from './TabsCDS.constants';

export const getTabsStyles = tabsStyle => ({
  '&.MuiTabs-root': {
    borderBottom: ({ palette }) =>
      `1px solid ${
        tabsStyle === TabsStyle.ON_PAGE ? palette.border.input : palette.border.default
      }`,
  },
});
